import React from "react";
import dayjs from "dayjs";
import { formatValueBrl } from "../../../../../../../function/utilis/function";
import styles from "./GroupFaturamento.module.css";

/** Um par rótulo/valor. Mostra um placeholder em itálico quando o dado não veio preenchido. */
function Campo({ rotulo, valor, largo }) {
  const vazio = valor === null || valor === undefined || valor === "";
  return (
    <div className={`${styles.campo} ${largo ? styles.campoLargo : ""}`}>
      <span className={styles.rotulo}>{rotulo}</span>
      <span className={vazio ? styles.valorVazio : styles.valor}>{vazio ? "Não informado" : valor}</span>
    </div>
  );
}

export function GroupFaturamento({ info }) {
  const dataVencimento = info.dataVencimento ? dayjs(info.dataVencimento) : null;
  const dataVencimentoValida = dataVencimento && dataVencimento.isValid();

  return (
    <div className={styles.painel}>
      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Cobrança</h4>
        <div className={styles.grade}>
          <Campo rotulo="Data de Vencimento" valor={dataVencimentoValida ? dataVencimento.format("DD/MM/YYYY") : null} />
          <Campo rotulo="Descrição" valor={info.descricao} largo />
          <Campo rotulo="Valor Avulso" valor={formatValueBrl(info.valorAvulso)} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Valores e recorrência</h4>
        <div className={styles.grade}>
          <Campo rotulo="Valor Mensal" valor={formatValueBrl(info.valorMensal)} />
          <Campo rotulo="Valor Assinatura" valor={formatValueBrl(info.valorAssinatura)} />
          <Campo rotulo="Valor Adicional" valor={formatValueBrl(info.valorAdicional)} />
          <Campo rotulo="Número Recorrências" valor={info.qtdRecorrencias} />
          <Campo rotulo="Forma Pagamento" valor={info.formaPagamentoId} />
        </div>
      </div>

      <div className={styles.grupo}>
        <h4 className={styles.grupoTitulo}>Negociação</h4>
        <p className={info.observacaoNegociacao ? styles.textoLongo : styles.textoLongoVazio}>
          {info.observacaoNegociacao || "Nenhuma negociação registrada"}
        </p>
      </div>
    </div>
  );
}

export default GroupFaturamento;
